// import enLang from "./entries/en-US";
// import arLang from "./entries/ar_SA";

import arLang from "../../IngProvider/Entries/ar_SA";
import EnLang from "../../IngProvider/Entries/en_US";

const AppLocale = {
  en: EnLang,
  ar: arLang,
};

export default AppLocale;
